import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'

import {useInView} from '@vio/core/src/_web/utils/browser/hooks/useInView'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Team
} from '@vio/core/src/analytics/types/Events'

export const HotelQuestionViewTracker = ({entity}: {entity: Entity}) => {
  const dispatch = useDispatch()
  const {ref, inView} = useInView({triggerOnce: true, threshold: 0.5})

  useEffect(() => {
    if (inView) {
      dispatch(
        trackEvent({
          category: Category.User,
          entity,
          action: Action.Viewed,
          team: Team.Select
        })
      )
    }
  }, [dispatch, inView, entity])

  return <div ref={ref} />
}
